import axiosInstance from "../../../components/authentication/helper/axiosApi";
import { ActionTypes } from "../../constants/action-types";
import { fetchDashboardAction } from "../dashboard/dashboardAction";

export const fetchPerformanceAction = (profileId) => {
    return async (dispatch) => {
        try {

            const response = await axiosInstance.get(`/api/performance/${profileId}/`);

            dispatch({
                type: ActionTypes.SET_PERFORMANCE,
                payload: response.data,
            });
        } catch (error) {

        }
    };
};

export const updatePerformanceAction = (profileId, updateData) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.put(`/api/performance/${profileId}/`, updateData);
            dispatch({
                type: ActionTypes.SET_PERFORMANCE,
                payload: response.data,
            });
            dispatch(fetchDashboardAction())
        } catch (error) {

        }
    };
};


export const sendProfileConnectionAction = (data) => {
    return async (dispatch) => {
        try {
            await axiosInstance.post(`/api/network/sendProfilePdf/`, data);

        } catch (error) {

        }
    };
};

// send my profile 
export const fetchSendMyProfileAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/network/send_my_profile/`);
            dispatch({
                type: ActionTypes.FETCH_SEND_MY_PROFILE_REQUEST,
                payload: response.data,
            });
            
        } catch (error) {

        }
    };
};







